import { Box, Stack, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import IntegrationsMarketplace from './IntegrationsMarketPlace';
import MyIntegrations from './MyIntegrations';

type IntegrationsTabOptions = 'my-integrations' | 'marketplace';

function IntegrationsLayout() {
  const [currentTab, setCurrentTab] =
    useState<IntegrationsTabOptions>('my-integrations');

  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: IntegrationsTabOptions
  ) => {
    setCurrentTab(newValue);
  };
  return (
    <Stack spacing={3} m={2}>
      <Tabs
        aria-label="context-visualizer-tabs"
        onChange={handleTabChange}
        role="navigation"
        value={currentTab}
      >
        <Tab label="Installed" value="my-integrations" />
        <Tab label="Marketplace" value="marketplace" />
      </Tabs>
      <Box mt={2} mx={5} px={3}>
        {currentTab === 'my-integrations' && <MyIntegrations />}
        {currentTab === 'marketplace' && <IntegrationsMarketplace />}
      </Box>
    </Stack>
  );
}

export default IntegrationsLayout;
